import React from 'react';
import "./Resume.scss";

export default function ExperienceComponent(props) {

    return(
        <div className="row w-100 m-1 d-flex flex-row">
            <div className="col-4 sub-header-main align-items-center d-flex justify-content-center">
                <p>{props.startYear} - {props.endYear}</p>
            </div>
            <div className="col-8">
                <p className="sub-header-main">{props.pName}</p>
                <p className="description-main">{props.pDescription}</p>
            </div>
        </div>
    );
}